{
	"dateInfoNotAvailable": "Affichage non disponible",
	"monthDays": "Total {{monthDays}} jours"
}
